import Button from '@repo/ui/button'
import { UserCanceledIcon } from '@repo/ui/icons'
import Modal, { MODAL_BODY_CLASSNAME } from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { removeCenterEnrollments } from '../../../api/centers/remove-center-enrollments'
import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import { modalButtonConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { queryClient } from '../../../main'
import { DeaffectEnrollmentCenterForm } from './enrollment-form/deaffect-enrollment-form'

type Props = {
  centerId: number
  id: number
  onSuccess?: () => void
}

const DeaffectEnrollmentCenter = ({ id, centerId, onSuccess }: Props) => {
  const { modalState, toggleModal, closeModel } = useModalManager<'deaffect-enrollment'>([
    'deaffect-enrollment'
  ])
  const { mutateAsync: cancelEnrollmentMutation } = useMutation({
    mutationFn: removeCenterEnrollments,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Désaffectation du centre réussie')
      closeModel('deaffect-enrollment')
      queryClient.invalidateQueries({ queryKey: ['enrollments'] })
      if (onSuccess) onSuccess()
    }
  })
  return (
    <div>
      <Button
        variant={'destructive'}
        icon={UserCanceledIcon}
        className="text-nowrap"
        label="Désaffecter du centre"
        onClick={() => toggleModal('deaffect-enrollment')}
      />

      {/* deaffect enrollment modal */}
      <Modal
        hideActions
        icon={UserCanceledIcon}
        isOpen={modalState['deaffect-enrollment']}
        onCancel={() => toggleModal('deaffect-enrollment')}
        title={'Désaffecter du centre'}
      >
        <DeaffectEnrollmentCenterForm
          defaultValues={{ enrollmentIds: [id], reason: undefined }}
          className={MODAL_BODY_CLASSNAME}
          buttonsConfig={modalButtonConfig({
            onCancel: () => closeModel('deaffect-enrollment'),
            onConfirm: async ({ reason, enrollmentIds }) =>
              cancelEnrollmentMutation({ id: centerId, enrollmentIds, reason })
          })}
        />
      </Modal>
    </div>
  )
}

export default DeaffectEnrollmentCenter
